import { LockedSpaceDefault } from "@circle-react/components/Spaces/Locked/LockedSpaceDefault";
import { BlockSelector } from "../Blocks";

interface Block {
  data: Record<string, unknown>;
  hidden: boolean;
  id: string;
  type: string;
}

interface BlocksViewerProps {
  blocks: Block[];
}

export const BlocksViewer = ({ blocks = [] }: BlocksViewerProps) => {
  const hasNonHiddenBlocks =
    Array.isArray(blocks) && blocks.some(block => !block?.hidden);

  if (hasNonHiddenBlocks) {
    return (
      <div className="bg-primary text-dark flex h-full flex-col gap-y-10">
        {blocks
          .filter(block => !block.hidden)
          .map(block => (
            <BlockSelector key={block.id} block={block} />
          ))}
      </div>
    );
  }

  return (
    <div className="bg-secondary text-dark h-full">
      <div className="h-full sm:p-6 lg:mx-auto lg:max-w-5xl">
        <LockedSpaceDefault />
      </div>
    </div>
  );
};

export default BlocksViewer;
